module.exports = __webpack_public_path__ + "img/yuanwei3.e7ae7ea5.gif";